import { render, staticRenderFns } from "./BuySellListingTable.vue?vue&type=template&id=61630bc3&scoped=true"
import script from "./BuySellListingTable.vue?vue&type=script&lang=js"
export * from "./BuySellListingTable.vue?vue&type=script&lang=js"
import style0 from "./BuySellListingTable.vue?vue&type=style&index=0&id=61630bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61630bc3",
  null
  
)

export default component.exports